import { APIMethod, fetchData } from "@client";

export async function removeWorkspaceQuery(uuid) {
  const res = await fetchData(`/workspace/${uuid}`, APIMethod.DELETE);
  
  return res.results;
}
